import React from 'react'
import { FormControl, MenuItem, Select, InputLabel } from '@mui/material'

const allowedDemoTokenDurations = [1, 2, 3, 4, 5, 6, 7, 14, 30, 60, 90, 120]

interface Props {
  onChange: any
  value: number
}

export function TokenDurationField(props: Props) {
  return (
    <FormControl fullWidth>
      <InputLabel id="token_duration_label">Account length in Days</InputLabel>
      <Select
        labelId="token_duration_label"
        name="token_duration_days"
        value={props.value}
        onChange={props.onChange}
        label="Account Length in Days"
      >
        {allowedDemoTokenDurations.map((val) => {
          return (
            <MenuItem key={val} value={val}>
              {val}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}
